
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorDeleteIcon as ObiCursorDeleteIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-delete-icon.js';
 
 
 

 
 export const ObiCursorDeleteIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-delete-icon',
   elementClass: ObiCursorDeleteIconElement,
   events: {
     
   }
  });
 
 